import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateMaintenance,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data(select_data);
      setUpdate_modal_data((prevData) => ({
        ...prevData,
      }));
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUpdate_modal_data({
      ...update_modal_data,
      [name]: value,
    });
  };

  const validateFields = () => {
    const newErrors = {};
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;

          if (!_id) {
            throw new Error("ID is not defined");
          }

          const payload = {
            serviceType: update_modal_data.serviceType,
            status: update_modal_data.status,
            notes: update_modal_data.notes,
            lastServiceDate: update_modal_data.lastServiceDate,
            lastServiceKm: update_modal_data.lastServiceKm,
            amount: update_modal_data.amount,
          };

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v4/maintenance-check/${_id}`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            },
          );

          if (res.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Update Success",
              text: "Maintenance record updated successfully.",
              confirmButtonText: "OK",
            });

            onUpdateMaintenance(res.data.record || update_modal_data);
            setRen(!ren);
            set_update_data_modal_Show(false);
          }
        } catch (error) {
          console.error("Update maintenance error:", error);

          Swal.fire(
            "Update failed",
            error.response?.data?.message || "Something went wrong",
            "error",
          );
        }
      }
    });
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Vehicle Maintenance Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={update_modal_data.status || ""}
                onChange={handleChange}
              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Service Type</Form.Label>

              <Form.Control
                as="select"
                name="serviceType"
                value={update_modal_data.serviceType || ""}
                onChange={handleChange}
              >
                <option value="">Select Service Type</option>
                <option value="First">First</option>
                <option value="Second">Second</option>
                <option value="Third">Third</option>
                <option value="Fixed">Fixed</option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Service Date</Form.Label>
              <Form.Control
                type="date"
                name="lastServiceDate"
                value={
                  update_modal_data.lastServiceDate
                    ? new Date(update_modal_data.lastServiceDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Service KM</Form.Label>
              <Form.Control
                type="number"
                name="lastServiceKm"
                value={update_modal_data.lastServiceKm ?? ""}
                onChange={handleChange}
                placeholder="Enter last service KM"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={update_modal_data.amount ?? ""}
                onChange={handleChange}
                placeholder="Enter maintenance amount"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Notes </Form.Label>
              <Form.Control
                type="text"
                name="notes"
                value={update_modal_data.notes || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Vehicle Maintenance
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
